const state = {
  addressList: {
    result: {}, // "errorMessage": "정상","countPerPage": "10","totalCount": "0","errorCode": "0","currentPage": 1
    contents: [],
  },
};

export default state;
